<div class="upld-wrap">
  <div class="upld-ttl">
    <h4>Upload image</h4>
    <button class="cls-dlg-cls" mat-dialog-close="false" mat-button (click)="onclose()"><i class="material-icons">close</i></button>
  </div>
  <mat-card-content>
    <input id="myInput" #myInput type="file" (change)="fileChangeEvent($event)" />
    <mat-hint align="start">*Image size should be less than 2 MB</mat-hint>
    <div>
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1/ 1"
        [resizeToWidth]="100" format="jpeg" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
        (loadImageFailed)="loadImageFailed()" [style.display]="cropperReady ? null : 'none'">
      </image-cropper>
    </div>
  </mat-card-content>
  <mat-dialog-actions>
    <button [disabled]="IsUploadFile" mat-raised-button [mat-dialog-close]="croppedImage">Submit</button>
  </mat-dialog-actions>
</div>
